import { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from 'features/toastSlice';
import { consumeSsoOrganization, exchangeSso } from 'api/sso';
import { completeCorporateLogin } from 'pages/auth/completeCorporateLogin';

const exchanges = new Map();

function exchangeOnce(code) {
  const key = code || '';
  if (!exchanges.has(key)) {
    const idPublicOrg = consumeSsoOrganization();
    const request = !code || !idPublicOrg
      ? Promise.reject(new Error('sso'))
      : exchangeSso(idPublicOrg, code);
    exchanges.set(key, request.then(
      (response) => ({ ok: true, data: response.data }),
      () => ({ ok: false }),
    ));
  }
  return exchanges.get(key);
}

function SsoCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  const appliedRef = useRef(false);
  const code = searchParams.get('code');

  useEffect(() => {
    let active = true;

    exchangeOnce(code).then((result) => {
      if (!active || appliedRef.current) {
        return;
      }
      appliedRef.current = true;
      if (!result.ok) {
        setFailed(true);
        dispatch(showErrorToast('auth.login.auth-error'));
        navigate('/auth/login', { replace: true });
        return;
      }
      completeCorporateLogin({ data: result.data, navigate, dispatch, t });
    });

    return () => {
      active = false;
    };
  }, [code, dispatch, navigate, t]);

  if (failed) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40vh',
      }}
      data-testid="sso-callback"
    >
      <CircularProgress aria-busy="true" aria-label="Loading" />
    </Box>
  );
}

export default SsoCallback;
